import { HEADER_ACTIVE, MENU_ACTIVE } from "../constant";
import { toLogin} from "@/util/login"
import { mapState, mapMutations } from "vuex";
import { SET_USER } from "../store/types";
import { FILE_URL_PREFIX, URL_API_BASE} from '../constant';
import { SaveLog } from '@/service/log'
export default {
    data () {
        return {
            HEADER_ACTIVE, MENU_ACTIVE, FILE_URL_PREFIX, URL_API_BASE
        }
    },
    computed: {
        ...mapState([
            'user'
        ]),
    },
    methods: {
        toLogin,
        ...mapMutations([
            SET_USER
        ]),
        filterValue(searchValue){
            return searchValue.replace(':', '\\:')
        },
        saveLog(eventKey,eventForm={}){
            // console.log(window.location.href);
            eventForm.url = window.location.href
            eventForm.eventKey = eventKey
            SaveLog(eventForm)
        },
        handleCascaderChange(){

        },
        deleteAdvanced(advancedSearch,index){
            advancedSearch.splice(index, 1);
        },
        addAdvanced(advancedSearch){
            advancedSearch.push(this.getObjAdvancedNull(advancedSearch))
        },
        getObjAdvancedNull(advancedArr){
            let advanced = JSON.parse(JSON.stringify(advancedArr[0]))
            advanced.field.value = null
            advanced.value = null
            // advanced.field.option = this.esField
            advanced.relation.value = 'AND'
            advanced.mysqlValueRela.value = 'LIKE'

            return advanced;
        },
        getMysqlDynamicQuery(mysqlDynamicSearch){
            let advancedQuery = ''
            for (let i = 0; i < mysqlDynamicSearch.length; i++) {
                let strategy = mysqlDynamicSearch[i]
                if (!strategy.value) {
                    continue
                }
                if (!strategy.field.value) {
                    continue
                }
                if (advancedQuery && strategy.relation.value) {
                    advancedQuery += ' ' + strategy.relation.value + ' '
                }
                advancedQuery += strategy.field.value ;
                if (strategy?.mysqlValueRela?.value){
                    advancedQuery += " "+strategy.mysqlValueRela.value+" ";
                    if(strategy.mysqlValueRela.value.indexOf("LIKE")>=0){
                        advancedQuery += "'%"+strategy.value.trim()+"%'";
                    }else{
                        advancedQuery += "'"+strategy.value.trim()+"'";
                    }
                }else{
                    advancedQuery += " like " + "'%"+strategy.value.trim()+"%'";
                }
            }
            return advancedQuery;
        },
        getAdvancedQuery(advancedSearch){
            let advancedQuery = ''
            for (let i = 0; i < advancedSearch.length; i++) {
                let strategy = advancedSearch[i]
                if (!strategy.value) {
                    continue
                }
                if (!strategy.field.value) {
                    continue
                }

                let fieldValue = '';
                if(Array.isArray(strategy.field.value)){
                    fieldValue = strategy.field.value.join(".")
                } else {
                    fieldValue = strategy.field.value || ''
                }
                
                if (advancedQuery && strategy.relation.value) {
                    advancedQuery += ' ' + strategy.relation.value + ' '
                }
                if(fieldValue.indexOf("_ik")>=0){
                    advancedQuery += '(' + fieldValue + ':(' + this.filterValue(strategy.value) + '))'
                }else{
                    advancedQuery += '(' + fieldValue + ':"' + this.filterValue(strategy.value) + '")'
                }
            }
            return advancedQuery
        },
        hasDot(num){
            if(num){
                return ( (num + '').indexOf('.') == -1 ) ? num : num.toFixed(2);
            }
        },
        getNowDate() {
            let now = ""
            let dateTime = new Date()
            let year = dateTime.getFullYear()
            now += year + '-'
            let month = dateTime.getMonth() + 1
            if (month < 10) {
                now += '0' + month + '-'
            } else {
                now += month + '-'
            }
            let date = dateTime.getDate()
            if (date < 10) {
                now += '0' + date + ' '
            } else {
                now += date + ' '
            }
            let hours = dateTime.getHours()
            if (hours < 10) {
                now += '0' + hours + ':'
            } else {
                now += hours + ':'
            }
            let minutes = dateTime.getMinutes()
            if (minutes < 10) {
                now += '0' + minutes
            } else {
                now += minutes
            }
            now +=":"+dateTime.getSeconds();
            return now;
        },
        getTimestamp() {
            return new Date(this.getNowDate()).getTime();
        },
        downBlobToPage(base64File, fileName) {
            var blob = this.Base64toBlob(base64File);
            var a = document.createElement('a');
            a.href = window.URL.createObjectURL(blob);
            a.setAttribute('download', fileName);
            a.target = 'downloadIframe';
            a.click();
            if (window.navigator.msSaveBlob) {
                window.navigator.msSaveBlob(blob, fileName);
            }
        },
        //将base64Data转换成blob对象
        Base64toBlob(base64Data) {
            var contentType = '';
            var sliceSize = 512;
            var byteCharacters = window.atob(base64Data)
            var byteArrays = []
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize)
                var byteNumbers = new Array(slice.length)
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i)
                }
                var byteArray = new Uint8Array(byteNumbers)
                byteArrays.push(byteArray)
            }
            var blob = new Blob(byteArrays, {type: contentType})
            return blob
        },

    },
  
}